export default "__VITE_ASSET__a6dc723a__"